'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _utils = require('../lib/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Button = function Button(props) {
  var title = props.title,
      label = props.label,
      customClassNames = props.customClassNames,
      onClick = props.onClick,
      otherFieldsErrorsCount = props.otherFieldsErrorsCount;


  return _react2.default.createElement(
    'div',
    { className: _classnames2.default.apply(undefined, ['field', 'buttonContainerField'].concat(_toConsumableArray((0, _utils.fixCustomClassNames)(customClassNames)))) },
    _react2.default.createElement(
      'div',
      { className: 'ui button', title: title, onClick: onClick },
      label
    ),
    otherFieldsErrorsCount > 0 && _react2.default.createElement(
      'label',
      { className: 'ui red basic label', style: { visibility: 'hidden' } },
      _lodash2.default.range(otherFieldsErrorsCount).map(function (i) {
        return _react2.default.createElement(
          'div',
          { key: i },
          '...'
        );
      })
    )
  );
};

Button.propTypes = {
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
  customClassNames: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  onClick: _propTypes2.default.func.isRequired,
  otherFieldsErrorsCount: _propTypes2.default.number,
  title: _propTypes2.default.string
};

exports.default = Button;


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/components/Button.js
// module id = 157
// module chunks = 0